import React, { useState } from "react";
import { Mail, Check } from "lucide-react";
import { toast } from "sonner";
import api from "../lib/api";

export default function EmailCapture({ scanId, name, source = "result_page", compact = false }) {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.includes("@")) {
      toast.error("Enter a valid email");
      return;
    }
    setLoading(true);
    try {
      await api.post("/subscribe", { email, scan_id: scanId, name, source });
      setDone(true);
      toast.success("Check your inbox — your glow-up report is on the way!");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not subscribe. Try again.");
    } finally {
      setLoading(false);
    }
  };

  if (done) {
    return (
      <div className="flex items-center gap-2 rounded-xl border border-success/30 bg-success/5 p-4 text-sm" data-testid="email-capture-done">
        <Check className="h-4 w-4 text-success" /> Your glow-up report is on its way. We'll send a weekly nudge to keep you improving.
      </div>
    );
  }

  return (
    <form onSubmit={submit} className={`rounded-xl border border-border bg-card ${compact ? "p-4" : "p-6"}`} data-testid="email-capture">
      <div className="flex items-center gap-2">
        <Mail className="h-4 w-4 text-primary" />
        <p className="font-display text-lg">{compact ? "Get your weekly glow-up report" : "Email me my glow-up report"}</p>
      </div>
      {!compact && <p className="mt-1 text-sm text-muted-foreground">Get this result + a personalised plan in your inbox, plus a weekly tip to keep improving.</p>}
      <div className="mt-3 flex flex-col gap-2 sm:flex-row">
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          data-testid="email-capture-input"
          className="flex-1 rounded-md border border-border bg-secondary/40 px-4 py-2.5 text-sm outline-none focus:border-primary/60"
        />
        <button
          type="submit"
          disabled={loading}
          data-testid="email-capture-submit"
          className="rounded-md bg-primary px-5 py-2.5 text-sm font-semibold text-primary-foreground transition hover:brightness-110 disabled:opacity-60"
        >
          {loading ? "Sending…" : "Send my report"}
        </button>
      </div>
    </form>
  );
}
